// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__Mgj0w","point":"Checkbox_point__ktnqs","active":"Checkbox_active__36RUH"};